// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3TZLQ","footer":"ModalInfo_footer__1iBPh"};